const externalVideos = document.querySelectorAll('.m-figure__video-wrapper--external');

externalVideos.forEach((externalVideo) => {
  externalVideo.querySelector('.m-figure__video-overlay-button').addEventListener('click', () => {
    const videoURL = externalVideo.dataset.video;

    externalVideo.querySelector('.m-figure__video').setAttribute('src', videoURL);
    externalVideo.querySelector('.m-figure__video-overlay').remove();
  });
});

// Audio Overlay

const podcasts = document.querySelectorAll('.o-podcast');

podcasts.forEach((podcast) => {
  if (podcast.querySelector('.m-figure__video-overlay').length > 0) {
    const podcastOverlayHeight = podcast.querySelector('.m-figure__video-overlay').clientHeight;
    podcast.querySelector('.m-figure__audio').style.marginBottom = `${podcastOverlayHeight * 0.6}px`; // eslint-disable-line no-param-reassign

    podcast.querySelector('.m-figure__video-overlay-button').addEventListener('click', () => {
      podcast.querySelector('.m-figure__video-overlay').remove();
      podcast.querySelector('.m-figure__audio').style.marginBottom = '0px'; // eslint-disable-line no-param-reassign
    });
  }
});
